export const THEME = {
    LIGHT: "cupcake",
    DARK: "dark",
}